import axios from 'axios';
import { url } from '../config';

// Redux Actions
import {
    FETCH_HOME,
    FETCH_HOME_FAILED,
    FETCH_HOME_START,
} from '../actions/index.jsx';

// Axios Request
export const fetchHome = () => {
    return function (dispatch) {
        dispatch({ type: FETCH_HOME_START });
        axios
            .get(`${url}/wp-json/wp/v2/pages?slug=homepagina`)

            .then((response) => {
                dispatch({
                    type: FETCH_HOME,
                    payload: response.data,
                });
            })

            .catch(function (error) {
                dispatch({
                    type: FETCH_HOME_FAILED,
                    payload: error,
                });
            });
    };
};



// WEBPACK FOOTER //
// ./src/requests/home_request.js